import { Row, Col } from 'react-bootstrap'
import React, { useMemo } from 'react'

const Stacked = ({ children }) => {
    const outputChildren = useMemo(() => {
        const kiddos = Array.isArray(children) ? children : [children]

        return kiddos.map(c => {
            return <Col md={12}>{c}</Col>
        })
    }, [children])

    return (
        <Row>
            {outputChildren}
        </Row>
    )
}

export default Stacked
